import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Collapse from '@material-ui/core/Collapse';
import { fontFamily, fontSize } from '../../../constants/text';
import { colors } from '../../../constants/colors';
import { biggerThanOrEqualTo } from '../../../core/util/styledComponents';
import { PRIMARY_RATING } from './PrimaryRatingSelector';
import TextField from '../../SolvPatternLibrary/TextField';

export const WHY_SOLV = 'why solv';
export const WHY_SOLV_OTHER = 'why solv other';

const LEARN = 'Learn about Solv';
const BOOK_URGENT = 'Book urgent care visit';
const BOOK_OTHER = 'Book other type of appointment';
const VIEW_INSURANCE = 'View insurance benefits';
const UPDATE_HEALTH = 'Update my health checklist';
const REVIEW = 'Review my health information';
const UPDATE_PROFILE = 'Update my profile';
const OTHER = 'Other';

const CHOICES = [
  LEARN,
  BOOK_URGENT,
  BOOK_OTHER,
  VIEW_INSURANCE,
  UPDATE_HEALTH,
  REVIEW,
  UPDATE_PROFILE,
  OTHER,
];

const Divider = styled.div`
  height: 1px;
  background-color: ${colors.dorianGrey};
  display: block;
  margin: 0 20px;

  ${biggerThanOrEqualTo.sm`
    width: 100%;
    margin: 0 auto;
  `}
`;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 26px 20px;
`;

const Title = styled.h1`
  margin: 0 auto 20px;
  display: block;
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.large};
  color: ${colors.blueMonday};
`;

const ChoicesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  max-width: 530px;
`;

const Choices = styled.div`
  max-width: 475px;
  display: flex;
  flex-direction: column;
`;

const Choice = styled(FormControlLabel)`
  margin: 0px;

  & .label {
    font-size: ${fontSize.default};
    color: ${colors.blueMonday};
    font-family: ${fontFamily.book};
    line-height: 28px;
    margin-left: 8px;
  }

  & .root {
    padding: 4px 0;
  }

  & .checked {
    stroke: ${colors.mrBlueSky};
    color: ${colors.mrBlueSky};
    stroke-width: 0;
  }
`;

const StyledTextField = styled(TextField)`
  background: ${colors.theWhiteAlbum};

  & .input-root {
    height: 36px;
    text-indent: 16px;
    width: 180px;
    padding: 12px 0;
  }
`;

type Props = {
  maryMagicSurvey?: any;
  onChange?: (...args: any[]) => any;
};

type State = any;

export default class WhySolvCheckboxes extends PureComponent<Props, State> {
  state = {
    [LEARN]: false,
    [BOOK_URGENT]: false,
    [BOOK_OTHER]: false,
    [VIEW_INSURANCE]: false,
    [UPDATE_HEALTH]: false,
    [REVIEW]: false,
    [UPDATE_PROFILE]: false,
    [OTHER]: false,
  };

  get checkedChoices() {
    // @ts-expect-error ts-migrate(7053) FIXME: No index signature with a parameter of type 'strin... Remove this comment to see the full error message
    return CHOICES.filter((choice) => this.state[choice]);
  }

  handleChange = (choice: any) => (event: any) => {
    this.setState({ [choice]: event.target.checked }, () =>
      // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      this.props.onChange({ value: this.checkedChoices, genre: WHY_SOLV })
    );
  };

  render() {
    const { maryMagicSurvey, onChange } = this.props;
    const midIdx = Math.ceil(CHOICES.length / 2);
    const leftChoices = CHOICES.slice(0, midIdx);
    const rightChoices = CHOICES.slice(midIdx);

    return (
      <Collapse in={!!maryMagicSurvey[PRIMARY_RATING]} timeout="auto">
        <>
          <Divider />

          <Root>
            <Title>Why did you come to Solv today?</Title>

            <ChoicesContainer>
              <Choices>
                {leftChoices.map((choice) => (
                  <Choice
                    classes={{ label: 'label' }}
                    control={
                      <Checkbox
                        // @ts-expect-error ts-migrate(7053) FIXME: No index signature with a parameter of type 'strin... Remove this comment to see the full error message
                        checked={this.state[choice]}
                        classes={{ checked: 'checked', root: 'root' }}
                        onChange={this.handleChange(choice)}
                      />
                    }
                    key={choice}
                    label={choice}
                  />
                ))}
              </Choices>

              <Choices>
                {rightChoices.map((choice) => (
                  <Choice
                    classes={{ label: 'label' }}
                    control={
                      <Checkbox
                        // @ts-expect-error ts-migrate(7053) FIXME: No index signature with a parameter of type 'strin... Remove this comment to see the full error message
                        checked={this.state[choice]}
                        classes={{ checked: 'checked', root: 'root' }}
                        onChange={this.handleChange(choice)}
                        size="small"
                      />
                    }
                    key={choice}
                    label={choice}
                  />
                ))}
                {this.state[OTHER] && (
                  <StyledTextField
                    classes={{ inputInput: 'input-root' }}
                    onChange={(e: any) =>
                      // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
                      onChange({ value: e.target.value, genre: WHY_SOLV_OTHER })
                    }
                  />
                )}
              </Choices>
            </ChoicesContainer>
          </Root>
        </>
      </Collapse>
    );
  }
}
